import React from 'react'
import styled from 'styled-components'
import logo from '../../assets/logo.png'
import colors from '../../styles/colors'

const StyledLogo = styled.div`
    display: flex;
    align-items: start;
    font-size: 40px;
    font-weight: 400;
    color: ${colors.second};
    padding: 40px 0;
    img {
        width: 40px;
    }
`

const Logo = () => {
    return (
        <StyledLogo>
            <img src={logo} alt="logo Salveat" />
            &nbsp;
            <div>Salveat</div>
        </StyledLogo>
    )
}

export default Logo
